import { render, staticRenderFns } from "./spec.vue?vue&type=template&id=5552718e&scoped=true"
import script from "./spec.vue?vue&type=script&lang=js"
export * from "./spec.vue?vue&type=script&lang=js"
import style0 from "./spec.vue?vue&type=style&index=0&id=5552718e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5552718e",
  null
  
)

export default component.exports